import React from "react";
import '../../css/secpage.css'

const Secpage = () => {
    return (
        <div className="secpage">
            <div className="secpage-wrapper">
                <div className="secpage-heading">
                    <h1>The Only Journey Is The Journey Within</h1>
                </div>
            </div>
        </div>
    )
}

export default Secpage;